import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const translations = {
  it: {
    // Nav
    dashboard: 'Dashboard',
    filaments: 'Filamenti',
    accessories: 'Accessori',
    calculator: 'Calcolatore',
    sales: 'Vendite',
    purchases: 'Acquisti',
    settings: 'Impostazioni',
    banners: 'Banner',
    admin_panel: 'Pannello',
    profile: 'Profilo',
    logout: 'Esci',
    light_theme: 'Tema Chiaro',
    dark_theme: 'Tema Scuro',
    admin: 'Admin',
    // Auth
    login: 'Accedi',
    register: 'Registrati',
    email: 'Email',
    password: 'Password',
    name: 'Nome',
    logging_in: 'Accesso...',
    registering: 'Registrazione...',
    no_account: 'Non hai un account?',
    have_account: 'Hai già un account?',
    forgot_password: 'Password dimenticata?',
    // Forgot/Reset
    forgot_title: 'Recupera Password',
    forgot_desc: 'Inserisci la tua email per ricevere il link di recupero',
    forgot_sent: 'Controlla la tua email',
    forgot_sent_msg: "Se l'email è registrata, riceverai un link per reimpostare la password.",
    forgot_check_spam: 'Controlla anche la cartella spam.',
    forgot_submit: 'Invia Link di Recupero',
    forgot_sending: 'Invio...',
    back_to_login: 'Torna al login',
    reset_title: 'Nuova Password',
    reset_desc: 'Inserisci la tua nuova password',
    reset_success: 'Password reimpostata con successo!',
    reset_submit: 'Reimposta Password',
    reset_saving: 'Salvataggio...',
    new_password: 'Nuova Password',
    confirm_password: 'Conferma Password',
    passwords_no_match: 'Le password non coincidono',
    password_min: 'La password deve avere almeno 6 caratteri',
    invalid_link: 'Link non valido. Richiedi un nuovo link di recupero.',
    go_to_login: 'Vai al Login',
    // Verify Email
    verify_title: 'Verifica Email',
    verify_loading: 'Verifica in corso...',
    verify_success: 'Email Verificata!',
    verify_success_msg: 'Il tuo account è stato confermato. Ora puoi accedere a tutte le funzionalità.',
    verify_error: 'Errore Verifica',
    go_to_dashboard: 'Vai alla Dashboard',
    // Email verification banner
    email_not_verified: 'Email non verificata',
    email_not_verified_msg: 'Verifica la tua email per accedere a tutte le funzionalità.',
    resend_email: 'Reinvia email di verifica',
    resend_sent: 'Email reinviata!',
    // Profile
    profile_title: 'Profilo',
    profile_desc: 'Gestisci il tuo account',
    change_password: 'Cambia Password',
    current_password: 'Password Attuale',
    save_changes: 'Salva Modifiche',
    saving: 'Salvataggio...',
    profile_updated: 'Profilo aggiornato',
    password_changed: 'Password cambiata con successo',
    language: 'Lingua',
    // Common
    search: 'Cerca',
    search_placeholder: 'Cerca prodotti, filamenti...',
    loading: 'Caricamento...',
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica',
    create: 'Crea',
    add: 'Aggiungi',
    close: 'Chiudi',
    confirm: 'Conferma',
    actions: 'Azioni',
    active: 'Attivo',
    inactive: 'Disattivato',
    yes: 'Sì',
    no: 'No',
    total: 'Totale',
    date: 'Data',
    status: 'Stato',
    // Dashboard
    total_revenue: 'Fatturato Totale',
    total_costs: 'Costi Totali',
    net_profit: 'Profitto Netto',
    to_collect: 'Da Incassare',
    top_products: 'Top Prodotti',
    monthly_trend: 'Trend Mensile',
    low_stock: 'Scorte Basse',
    recent_sales: 'Vendite Recenti',
    // Sales
    paid: 'Pagato',
    unpaid: 'Non Pagato',
    product_name: 'Nome Prodotto',
    quantity: 'Quantità',
    sale_price: 'Prezzo Vendita',
    cost: 'Costo',
    profit: 'Profitto',
    margin: 'Margine',
    // Calculator
    print_time: 'Tempo Stampa',
    design: 'Design',
    grams: 'Grammi',
    calculate: 'Calcola',
    save_sale: 'Salva Vendita',
    recent_prints: 'Stampe Recenti',
    manual_price: 'Prezzo Manuale',
    summary: 'Riepilogo',
    // Admin
    admin_title: 'Pannello di Controllo',
    admin_desc: 'Gestione utenti, newsletter e monitoraggio',
    users: 'Utenti',
    verified: 'Verificati',
    pending: 'In Attesa',
    newsletter: 'Newsletter',
    email_log: 'Email Log',
    sent: 'Inviate',
    send_newsletter: 'Invia Newsletter',
    subject: 'Oggetto',
    body: 'Testo',
    recipients: 'destinatari',
    newsletter_note: 'La newsletter verrà inviata a tutti gli utenti con email verificata.',
    newsletter_sim: 'Nota: le email sono simulate finché non configuri un servizio email reale.',
    verify_user: 'Verifica',
    remove_admin: 'Rimuovi Admin',
    registered: 'Registrato',
    copy_link: 'Copia Link',
    no_email_logs: 'Nessun log email',
    no_newsletters: 'Nessuna newsletter inviata',
    // Banners
    banner_title: 'Gestione Banner',
    banner_desc: 'Inserisci codici TradeTracker o HTML personalizzati',
    new_banner: 'Nuovo Banner',
    edit_banner: 'Modifica Banner',
    position: 'Posizione',
    html_code: 'Codice HTML / iframe',
    header: 'Header (sopra contenuto)',
    sidebar: 'Sidebar (sotto menu)',
    footer: 'Footer (fondo pagina)',
    content: 'Sotto Contenuto',
    no_banners: 'Nessun banner',
    preview: 'Anteprima Banner Attivi',
  },
  en: {
    dashboard: 'Dashboard',
    filaments: 'Filaments',
    accessories: 'Accessories',
    calculator: 'Calculator',
    sales: 'Sales',
    purchases: 'Purchases',
    settings: 'Settings',
    banners: 'Banners',
    admin_panel: 'Panel',
    profile: 'Profile',
    logout: 'Logout',
    light_theme: 'Light Theme',
    dark_theme: 'Dark Theme',
    admin: 'Admin',
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    logging_in: 'Logging in...',
    registering: 'Registering...',
    no_account: "Don't have an account?",
    have_account: 'Already have an account?',
    forgot_password: 'Forgot password?',
    forgot_title: 'Recover Password',
    forgot_desc: 'Enter your email to receive a recovery link',
    forgot_sent: 'Check your email',
    forgot_sent_msg: 'If the email is registered, you will receive a link to reset your password.',
    forgot_check_spam: 'Also check your spam folder.',
    forgot_submit: 'Send Recovery Link',
    forgot_sending: 'Sending...',
    back_to_login: 'Back to login',
    reset_title: 'New Password',
    reset_desc: 'Enter your new password',
    reset_success: 'Password reset successfully!',
    reset_submit: 'Reset Password',
    reset_saving: 'Saving...',
    new_password: 'New Password',
    confirm_password: 'Confirm Password',
    passwords_no_match: 'Passwords do not match',
    password_min: 'Password must be at least 6 characters',
    invalid_link: 'Invalid link. Request a new recovery link.',
    go_to_login: 'Go to Login',
    verify_title: 'Email Verification',
    verify_loading: 'Verifying...',
    verify_success: 'Email Verified!',
    verify_success_msg: 'Your account has been confirmed. You can now access all features.',
    verify_error: 'Verification Error',
    go_to_dashboard: 'Go to Dashboard',
    email_not_verified: 'Email not verified',
    email_not_verified_msg: 'Verify your email to access all features.',
    resend_email: 'Resend verification email',
    resend_sent: 'Email resent!',
    profile_title: 'Profile',
    profile_desc: 'Manage your account',
    change_password: 'Change Password',
    current_password: 'Current Password',
    save_changes: 'Save Changes',
    saving: 'Saving...',
    profile_updated: 'Profile updated',
    password_changed: 'Password changed successfully',
    language: 'Language',
    search: 'Search',
    search_placeholder: 'Search products, filaments...',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    add: 'Add',
    close: 'Close',
    confirm: 'Confirm',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Disabled',
    yes: 'Yes',
    no: 'No',
    total: 'Total',
    date: 'Date',
    status: 'Status',
    total_revenue: 'Total Revenue',
    total_costs: 'Total Costs',
    net_profit: 'Net Profit',
    to_collect: 'To Collect',
    top_products: 'Top Products',
    monthly_trend: 'Monthly Trend',
    low_stock: 'Low Stock',
    recent_sales: 'Recent Sales',
    paid: 'Paid',
    unpaid: 'Unpaid',
    product_name: 'Product Name',
    quantity: 'Quantity',
    sale_price: 'Sale Price',
    cost: 'Cost',
    profit: 'Profit',
    margin: 'Margin',
    print_time: 'Print Time',
    design: 'Design',
    grams: 'Grams',
    calculate: 'Calculate',
    save_sale: 'Save Sale',
    recent_prints: 'Recent Prints',
    manual_price: 'Manual Price',
    summary: 'Summary',
    admin_title: 'Control Panel',
    admin_desc: 'User management, newsletters and monitoring',
    users: 'Users',
    verified: 'Verified',
    pending: 'Pending',
    newsletter: 'Newsletter',
    email_log: 'Email Log',
    sent: 'Sent',
    send_newsletter: 'Send Newsletter',
    subject: 'Subject',
    body: 'Body',
    recipients: 'recipients',
    newsletter_note: 'Newsletter will be sent to all users with verified email.',
    newsletter_sim: 'Note: emails are simulated until you configure a real email service.',
    verify_user: 'Verify',
    remove_admin: 'Remove Admin',
    registered: 'Registered',
    copy_link: 'Copy Link',
    no_email_logs: 'No email logs',
    no_newsletters: 'No newsletters sent',
    banner_title: 'Banner Management',
    banner_desc: 'Insert TradeTracker codes or custom HTML',
    new_banner: 'New Banner',
    edit_banner: 'Edit Banner',
    position: 'Position',
    html_code: 'HTML Code / iframe',
    header: 'Header (above content)',
    sidebar: 'Sidebar (below menu)',
    footer: 'Footer (bottom of page)',
    content: 'Below Content',
    no_banners: 'No banners',
    preview: 'Active Banner Preview',
  },
  es: {
    dashboard: 'Panel',
    filaments: 'Filamentos',
    accessories: 'Accesorios',
    calculator: 'Calculadora',
    sales: 'Ventas',
    purchases: 'Compras',
    settings: 'Configuración',
    banners: 'Banners',
    admin_panel: 'Panel',
    profile: 'Perfil',
    logout: 'Salir',
    light_theme: 'Tema Claro',
    dark_theme: 'Tema Oscuro',
    admin: 'Admin',
    login: 'Iniciar sesión',
    register: 'Registrarse',
    email: 'Email',
    password: 'Contraseña',
    name: 'Nombre',
    logging_in: 'Iniciando sesión...',
    registering: 'Registrando...',
    no_account: '¿No tienes cuenta?',
    have_account: '¿Ya tienes cuenta?',
    forgot_password: '¿Olvidaste tu contraseña?',
    forgot_title: 'Recuperar Contraseña',
    forgot_desc: 'Ingresa tu email para recibir el enlace de recuperación',
    forgot_sent: 'Revisa tu email',
    forgot_sent_msg: 'Si el email está registrado, recibirás un enlace para restablecer tu contraseña.',
    forgot_check_spam: 'Revisa también la carpeta de spam.',
    forgot_submit: 'Enviar Enlace',
    forgot_sending: 'Enviando...',
    back_to_login: 'Volver al inicio',
    reset_title: 'Nueva Contraseña',
    reset_desc: 'Ingresa tu nueva contraseña',
    reset_success: '¡Contraseña restablecida!',
    reset_submit: 'Restablecer Contraseña',
    reset_saving: 'Guardando...',
    new_password: 'Nueva Contraseña',
    confirm_password: 'Confirmar Contraseña',
    passwords_no_match: 'Las contraseñas no coinciden',
    password_min: 'La contraseña debe tener al menos 6 caracteres',
    invalid_link: 'Enlace no válido. Solicita un nuevo enlace.',
    go_to_login: 'Ir al Login',
    verify_title: 'Verificación de Email',
    verify_loading: 'Verificando...',
    verify_success: '¡Email Verificado!',
    verify_success_msg: 'Tu cuenta ha sido confirmada. Ahora puedes acceder a todas las funciones.',
    verify_error: 'Error de Verificación',
    go_to_dashboard: 'Ir al Panel',
    email_not_verified: 'Email no verificado',
    email_not_verified_msg: 'Verifica tu email para acceder a todas las funciones.',
    resend_email: 'Reenviar email de verificación',
    resend_sent: '¡Email reenviado!',
    profile_title: 'Perfil',
    profile_desc: 'Gestiona tu cuenta',
    change_password: 'Cambiar Contraseña',
    current_password: 'Contraseña Actual',
    save_changes: 'Guardar Cambios',
    saving: 'Guardando...',
    profile_updated: 'Perfil actualizado',
    password_changed: 'Contraseña cambiada',
    language: 'Idioma',
    search: 'Buscar',
    search_placeholder: 'Buscar productos, filamentos...',
    loading: 'Cargando...',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    add: 'Añadir',
    close: 'Cerrar',
    confirm: 'Confirmar',
    actions: 'Acciones',
    active: 'Activo',
    inactive: 'Desactivado',
    yes: 'Sí',
    no: 'No',
    total: 'Total',
    date: 'Fecha',
    status: 'Estado',
    total_revenue: 'Ingresos Totales',
    total_costs: 'Costos Totales',
    net_profit: 'Beneficio Neto',
    to_collect: 'Por Cobrar',
    top_products: 'Top Productos',
    monthly_trend: 'Tendencia Mensual',
    low_stock: 'Stock Bajo',
    recent_sales: 'Ventas Recientes',
    paid: 'Pagado',
    unpaid: 'No Pagado',
    product_name: 'Nombre del Producto',
    quantity: 'Cantidad',
    sale_price: 'Precio de Venta',
    cost: 'Costo',
    profit: 'Beneficio',
    margin: 'Margen',
    print_time: 'Tiempo de Impresión',
    design: 'Diseño',
    grams: 'Gramos',
    calculate: 'Calcular',
    save_sale: 'Guardar Venta',
    recent_prints: 'Impresiones Recientes',
    manual_price: 'Precio Manual',
    summary: 'Resumen',
    admin_title: 'Panel de Control',
    admin_desc: 'Gestión de usuarios, newsletters y monitoreo',
    users: 'Usuarios',
    verified: 'Verificados',
    pending: 'Pendientes',
    newsletter: 'Newsletter',
    email_log: 'Log de Email',
    sent: 'Enviadas',
    send_newsletter: 'Enviar Newsletter',
    subject: 'Asunto',
    body: 'Texto',
    recipients: 'destinatarios',
    newsletter_note: 'La newsletter se enviará a todos los usuarios con email verificado.',
    newsletter_sim: 'Nota: los emails son simulados hasta que configures un servicio real.',
    verify_user: 'Verificar',
    remove_admin: 'Quitar Admin',
    registered: 'Registrado',
    copy_link: 'Copiar Enlace',
    no_email_logs: 'Sin logs de email',
    no_newsletters: 'Sin newsletters enviadas',
    banner_title: 'Gestión de Banners',
    banner_desc: 'Inserta códigos TradeTracker o HTML personalizado',
    new_banner: 'Nuevo Banner',
    edit_banner: 'Editar Banner',
    position: 'Posición',
    html_code: 'Código HTML / iframe',
    header: 'Header (arriba del contenido)',
    sidebar: 'Sidebar (debajo del menú)',
    footer: 'Footer (fondo de página)',
    content: 'Debajo del Contenido',
    no_banners: 'Sin banners',
    preview: 'Vista Previa de Banners Activos',
  },
  fr: {
    dashboard: 'Tableau de bord',
    filaments: 'Filaments',
    accessories: 'Accessoires',
    calculator: 'Calculateur',
    sales: 'Ventes',
    purchases: 'Achats',
    settings: 'Paramètres',
    banners: 'Bannières',
    admin_panel: 'Panneau',
    profile: 'Profil',
    logout: 'Déconnexion',
    light_theme: 'Thème Clair',
    dark_theme: 'Thème Sombre',
    admin: 'Admin',
    login: 'Connexion',
    register: "S'inscrire",
    email: 'Email',
    password: 'Mot de passe',
    name: 'Nom',
    logging_in: 'Connexion...',
    registering: 'Inscription...',
    no_account: "Pas de compte ?",
    have_account: 'Déjà un compte ?',
    forgot_password: 'Mot de passe oublié ?',
    forgot_title: 'Récupérer Mot de Passe',
    forgot_desc: 'Entrez votre email pour recevoir le lien de récupération',
    forgot_sent: 'Vérifiez votre email',
    forgot_sent_msg: "Si l'email est enregistré, vous recevrez un lien pour réinitialiser votre mot de passe.",
    forgot_check_spam: 'Vérifiez aussi le dossier spam.',
    forgot_submit: 'Envoyer le Lien',
    forgot_sending: 'Envoi...',
    back_to_login: 'Retour à la connexion',
    reset_title: 'Nouveau Mot de Passe',
    reset_desc: 'Entrez votre nouveau mot de passe',
    reset_success: 'Mot de passe réinitialisé !',
    reset_submit: 'Réinitialiser',
    reset_saving: 'Sauvegarde...',
    new_password: 'Nouveau Mot de Passe',
    confirm_password: 'Confirmer le Mot de Passe',
    passwords_no_match: 'Les mots de passe ne correspondent pas',
    password_min: 'Le mot de passe doit contenir au moins 6 caractères',
    invalid_link: 'Lien invalide. Demandez un nouveau lien.',
    go_to_login: 'Aller à la Connexion',
    verify_title: "Vérification d'Email",
    verify_loading: 'Vérification...',
    verify_success: 'Email Vérifié !',
    verify_success_msg: 'Votre compte a été confirmé. Vous pouvez maintenant accéder à toutes les fonctionnalités.',
    verify_error: 'Erreur de Vérification',
    go_to_dashboard: 'Aller au Tableau de bord',
    email_not_verified: 'Email non vérifié',
    email_not_verified_msg: 'Vérifiez votre email pour accéder à toutes les fonctionnalités.',
    resend_email: "Renvoyer l'email de vérification",
    resend_sent: 'Email renvoyé !',
    profile_title: 'Profil',
    profile_desc: 'Gérer votre compte',
    change_password: 'Changer le Mot de Passe',
    current_password: 'Mot de Passe Actuel',
    save_changes: 'Sauvegarder',
    saving: 'Sauvegarde...',
    profile_updated: 'Profil mis à jour',
    password_changed: 'Mot de passe changé',
    language: 'Langue',
    search: 'Rechercher',
    search_placeholder: 'Rechercher produits, filaments...',
    loading: 'Chargement...',
    save: 'Sauvegarder',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    create: 'Créer',
    add: 'Ajouter',
    close: 'Fermer',
    confirm: 'Confirmer',
    actions: 'Actions',
    active: 'Actif',
    inactive: 'Désactivé',
    yes: 'Oui',
    no: 'Non',
    total: 'Total',
    date: 'Date',
    status: 'Statut',
    total_revenue: 'Chiffre d\'Affaires',
    total_costs: 'Coûts Totaux',
    net_profit: 'Bénéfice Net',
    to_collect: 'À Encaisser',
    top_products: 'Top Produits',
    monthly_trend: 'Tendance Mensuelle',
    low_stock: 'Stock Bas',
    recent_sales: 'Ventes Récentes',
    paid: 'Payé',
    unpaid: 'Non Payé',
    product_name: 'Nom du Produit',
    quantity: 'Quantité',
    sale_price: 'Prix de Vente',
    cost: 'Coût',
    profit: 'Bénéfice',
    margin: 'Marge',
    print_time: "Temps d'Impression",
    design: 'Design',
    grams: 'Grammes',
    calculate: 'Calculer',
    save_sale: 'Enregistrer la Vente',
    recent_prints: 'Impressions Récentes',
    manual_price: 'Prix Manuel',
    summary: 'Résumé',
    admin_title: 'Panneau de Contrôle',
    admin_desc: 'Gestion des utilisateurs, newsletters et suivi',
    users: 'Utilisateurs',
    verified: 'Vérifiés',
    pending: 'En Attente',
    newsletter: 'Newsletter',
    email_log: 'Log Email',
    sent: 'Envoyées',
    send_newsletter: 'Envoyer Newsletter',
    subject: 'Objet',
    body: 'Texte',
    recipients: 'destinataires',
    newsletter_note: 'La newsletter sera envoyée à tous les utilisateurs avec email vérifié.',
    newsletter_sim: "Note : les emails sont simulés tant que vous n'avez pas configuré un service réel.",
    verify_user: 'Vérifier',
    remove_admin: 'Retirer Admin',
    registered: 'Inscrit',
    copy_link: 'Copier le Lien',
    no_email_logs: "Aucun log d'email",
    no_newsletters: 'Aucune newsletter envoyée',
    banner_title: 'Gestion des Bannières',
    banner_desc: 'Insérez des codes TradeTracker ou du HTML personnalisé',
    new_banner: 'Nouvelle Bannière',
    edit_banner: 'Modifier la Bannière',
    position: 'Position',
    html_code: 'Code HTML / iframe',
    header: 'Header (au-dessus du contenu)',
    sidebar: 'Sidebar (sous le menu)',
    footer: 'Footer (bas de page)',
    content: 'Sous le Contenu',
    no_banners: 'Aucune bannière',
    preview: 'Aperçu des Bannières Actives',
  }
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('fp_lang') || 'it');

  useEffect(() => {
    localStorage.setItem('fp_lang', lang);
  }, [lang]);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations['it']?.[key] || key;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const context = useContext(LangContext);
  if (!context) throw new Error('useLang must be used within LangProvider');
  return context;
}
